import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "./AddStepGoalModal.css";
import { titles } from "constants/titles";
import CustomButton from "components/widgets/custom-button/CustomButton";
import MessageSnackBar from "components/widgets/message-snackbar/MessageSnackBar";
import { updateStepGoal } from "redux/Devices/actions";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty, isSessionTimeExpired } from "utility";
import alerts from "constants/alerts";
import Loader from "react-spinners/ClipLoader";
import CustomInput from "components/widgets/custom-input/CustomInput";
import SessionExpiredPopup from "../session-expired-popup/SessionExpiredPopup";
import { StepIcon } from "assets/SVGs/StepIcon";
import { CrossIconBtn } from "assets/SVGs/SVGs";
import { useAdvancedValidation } from "hooks/useAdvancedValidation";

const AddStepGoalModal = ({ show, setShow, currentGoal }) => {
  const [stepCount, setStepCount] = useState("");
  const [verificationPopUp, setVerificationPopUp] = useState(false);
  const [fieldError, setFieldError] = useState(false);
  const [validationTriggered, setValidationTriggered] = useState(false);

  // Use advanced validation hook (same as mobile)
  const { snackbarState, dismissSnackbar, onApiResponse } = useAdvancedValidation();
  const { selectedDeviceDetails, loading } = useSelector(
    (store) => store?.devices
  );
  const userData = useSelector((store) => store?.auth?.userData);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (show) {
      setStepCount("");
      dismissSnackbar();
      setValidationTriggered(false);
      setFieldError(false);
    }
  }, [show]);

  const onClose = () => {
    setShow(false);
    dismissSnackbar();
    setValidationTriggered(false);
    setFieldError(false);
  };

  const handleClose = () => {
    onClose();
  };

  const handleStepCountChange = (value) => {
    setStepCount(value);
    // Clear error when user types
    if (validationTriggered && fieldError) {
      setFieldError(false);
      dismissSnackbar();
    }
  };

  const onSaveChanges = () => {
    let payload = {
      medical_alert_user_id: selectedDeviceDetails?.medical_alert_user_id,
      user_device_id: selectedDeviceDetails?.user_device_id,
      step_goal: parseInt(stepCount),
      userData: userData?.isGuestUser ? "guestuser" : "accountowner",
    };
    updateStepGoal({
      dispatch,
      payload,
      history,
      setSnackBarMessage: onApiResponse,
      onClose,
      medical_alert_user_id: selectedDeviceDetails?.medical_alert_user_id,
      userType: userData?.isGuestUser ? "guestuser" : "accountowner",
    });
  };

  const handleOnAddStepGoal = async () => {
    setValidationTriggered(true);
    let timeDifference = await isSessionTimeExpired();

    if (isEmpty(stepCount)) {
      setFieldError(true);
      // Show validation error (manual dismiss, not auto-hide)
      onApiResponse(alerts?.enter_steps, "error", 0);
      return;
    } else if (timeDifference && !userData?.isGuestUser) {
      setVerificationPopUp(true);
      return;
    } else {
      onSaveChanges();
    }
  };

  return (
    <Modal
      backdrop="true"
      aria-labelledby="contained-modal-title-vcenter"
      className="asg_container"
      show={show}
      onHide={handleClose}
    >
      {/* Snackbar inside modal, above white card (same as mobile) */}
      {snackbarState?.show && (
        <div className="modal_snackbar_wrapper">
          <MessageSnackBar
            message={snackbarState?.message}
            isVisible={true}
            type={snackbarState?.type}
            autoHideDuration={snackbarState?.autoHideDuration}
            constrainWidth={false}
            onDismiss={dismissSnackbar}
          />
        </div>
      )}

      {loading && (
        <div className="asg_loader_container">
          <Loader color="#DB4E3B" />
        </div>
      )}
      <Modal.Body className="asg_body">
          <div className="asg_header">
            <CrossIconBtn
              className="asg_cross_icon"
              onClick={() => setShow(!show)}
            />
          </div>

          <div className="asg_content">
          <div className="asg_icon_container">
            <StepIcon width="32" height="32" />
          </div>

          <h3 className="asg_title">{titles?.enter_step_goal}</h3>

          <div className="asg_input_section">
            <CustomInput
              className="asg_input_field"
              type="number"
              placeholder="Type Step Goal"
              value={stepCount}
              onChange={(e) => handleStepCountChange(e.target.value)}
            />
          </div>

          <div className="asg_buttons">
            <CustomButton
              className="asg_save_button"
              text={titles?.save_goal}
              width="100%"
              onClick={handleOnAddStepGoal}
            />
          </div>

          <p className="asg_current_goal_text">
            {`${titles?.current_goal} ${currentGoal} Steps`}
          </p>
        </div>
      </Modal.Body>
      {verificationPopUp ? (
        <SessionExpiredPopup
          isVisible={verificationPopUp}
          onClosePopup={(parentPopupHide) => {
            setVerificationPopUp(false);
            if (parentPopupHide) {
              onClose();
            }
          }}
          history={history}
        />
      ) : null}
    </Modal>
  );
};

export default AddStepGoalModal;
